'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { cva } from 'class-variance-authority'
import { useContext, type PropsWithChildren } from 'react'
import { DisclosurePanel, DisclosureStateContext } from 'react-aria-components'

const panelStyles = cva('mx-2 px-2', {
  variants: {
    isExpanded: {
      true: 'pb-2',
    },
  },
})

export function AccordionItemPanel({ className, children }: PropsWithChildren<UiComponentProps>) {
  const ctx = useContext(DisclosureStateContext)

  return (
    <DisclosurePanel
      data-testid="accordion-item/content"
      className={twMerge(panelStyles({ isExpanded: ctx?.isExpanded }), className)}
    >
      {children}
    </DisclosurePanel>
  )
}
